import { HttpStatusCode } from "axios";
import LoggedUserContext from "../model/auth/LoggedUserContext";
import Parameter from "../model/database/Parameter";
import ParameterDocumentFormatDTO from "../model/dto/ParameterDocumentFormatDTO";
import ParameterReminderDTO from "../model/dto/ParameterReminderDTO";
import http from "../utils/HttpCommon";

const getReminderParameters = async (context: LoggedUserContext) => {
	try {
		const response = await http.privateClient(context).get<any>('/parameters/reminder');

		if (response && response.status === HttpStatusCode.Ok) {
			return [response.status, response.data];
		}

		return [response ? response.status : undefined, undefined];

	} catch (e: any) {
		console.error(e);
		return [e.response.status, undefined];
	}
}

const getParameter = async (id: string, context: LoggedUserContext) => {
	try {
		const response = await http.privateClient(context).get<any>(`/parameters/${id}`);

		if (response && response.status === HttpStatusCode.Ok) {
			return [response.status, response.data];
		}

		return [response ? response.status : undefined, undefined];

	} catch (e: any) {
		console.error(e);
		return [e.response.status, undefined];
	}
}

const saveParameter = async (parameter: Parameter, context: LoggedUserContext) => {
	try {
		const response = await http.privateClient(context).post<any>('/parameters', parameter);

		if (response && response.status === HttpStatusCode.Ok) {
			return [response.status, response.data];
		}

		return [response ? response.status : undefined, undefined];

	} catch (e: any) {
		console.error(e);
		return [e.response.status, undefined];
	}
}

const getDocumentFormatParameters = async (context: LoggedUserContext) => {
	try {
		const response = await http.privateClient(context).get<any>('/parameters/productFormat');

		if (response && response.status === HttpStatusCode.Ok) {
			return [response.status, response.data];
		}

		return [response ? response.status : undefined, undefined];

	} catch (e: any) {
		console.error(e);
		return [e.response.status, undefined];
	}
}

const saveReminderParameters = async (context: LoggedUserContext, reminderParamenters: ParameterReminderDTO) => {
	try {
		const response = await http.privateClient(context).post<any>('/parameters/reminder', reminderParamenters);

		if (response && response.status === HttpStatusCode.Ok) {
			return [response.status, response.data];
		}

		return [response ? response.status : undefined, undefined];

	} catch (e: any) {
		console.error(e);
		return [e.response.status, undefined];
	}
}

const saveDocumentFormat = async (context: LoggedUserContext, documentFormatParameters: ParameterDocumentFormatDTO) => {
	try {
		const response = await http.privateClient(context).post<any>('/parameters/productFormat', documentFormatParameters);

		if (response && response.status === HttpStatusCode.Ok) {
			return [response.status, response.data];
		}

		return [response ? response.status : undefined, undefined];

	} catch (e: any) {
		console.error(e);
		return [e.response.status, undefined];
	}
}

const getInnovationPlazaParameters = async (context: LoggedUserContext) => {
	try {
		const response = await http.privateClient(context).get<any>('/parameters/innovationplaza');
		if (response && response.status === HttpStatusCode.Ok) return [response.status, response.data];
		return [response ? response.status : undefined, undefined];
	} catch (e: any) {
		console.error(e);
		return [e.response.status, undefined];
	}
}

const saveInnovationPlazaWatermark = async (context: LoggedUserContext, lastSync: string) => {
	try {
		const response = await http.privateClient(context).post<any>('/parameters/innovationplaza/watermark', { lastSync });
		if (response && response.status === HttpStatusCode.Ok) return [response.status, response.data];
		return [response ? response.status : undefined, undefined];
	} catch (e: any) {
		console.error(e);
		return [e.response.status, undefined];
	}
}

const triggerInnovationPlazaSync = async (context: LoggedUserContext) => {
	try {
		const response = await http.privateClient(context).post<any>('/parameters/innovationplaza/sync');
		if (response && (response.status === HttpStatusCode.Ok || response.status === 202)) return [response.status, response.data];
		return [response ? response.status : undefined, undefined];
	} catch (e: any) {
		console.error(e);
		return [e.response?.status, undefined];
	}
}

const ParameterService = {
	getReminderParameters,
    getDocumentFormatParameters,
    saveDocumentFormat,
    saveReminderParameters,
	getParameter,
	saveParameter,
	getInnovationPlazaParameters,
	saveInnovationPlazaWatermark,
	triggerInnovationPlazaSync,
}

export default ParameterService;